import { TemplateResult } from 'lit-html';
import './voy-modal';
import { ModalPos, VoyModal } from './voy-modal';

interface CreateModalOptions
{
    modalPos?: ModalPos;
    content: TemplateResult | HTMLElement;
}

export const VoyModalManager = new class
{
    createModal(options: CreateModalOptions)
    {
        const newModal = <VoyModal>(document.createElement('voy-modal'));
        
        newModal.content = options.content;
        if (options.modalPos) newModal.modalPos = options.modalPos;
        
        document.body.appendChild(newModal);

        return newModal;
    }
}